document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mega-menu').forEach(details => {
    let timeoutClose;

    details.addEventListener('mouseenter', () => {
      clearTimeout(timeoutClose);
      details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', () => {
      timeoutClose = setTimeout(() => {
        details.removeAttribute('open');
      }, 300); // Cierra después de 300ms si no vuelves a entrar
    });
  });
});
